import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../../hooks/useI18n';
import { buildLocalizedPath } from '../../seo/urls';

/**
 * SEO-only pricing content — rendered in DOM for crawlers, visually hidden from users.
 */
export const PricingSeoContent = () => {
  const { t, language } = useI18n();
  const faqItems = t('pricingFaq') || [];

  return (
    <div className="sr-only" aria-hidden="true">
      <section aria-labelledby="pricing-seo-overview-title">
        <h2 id="pricing-seo-overview-title">{t('pricingSeoOverviewTitle')}</h2>
        <p>{t('pricingSeoOverviewLead')}</p>
      </section>

      <section aria-labelledby="pricing-seo-models-title">
        <h2 id="pricing-seo-models-title">{t('pricingModelsTitle')}</h2>
        <p>{t('pricingModelsLead')}</p>
      </section>

      <section aria-labelledby="pricing-seo-platform-title">
        <h2 id="pricing-seo-platform-title">{t('pricingPlatformTitle')}</h2>
        <p>{t('pricingPlatformLead')}</p>
        <p>{t('pricingPublishedOnlyNote')}</p>
      </section>

      <section aria-labelledby="pricing-seo-faq-title">
        <h2 id="pricing-seo-faq-title">{t('pricingFaqTitle')}</h2>
        <div>
          {faqItems.map((item) => (
            <article key={item.question}>
              <h3>{item.question}</h3>
              <p>{item.answer}</p>
            </article>
          ))}
        </div>
        <p>
          {t('pricingSeoInternalLinksLead')}{' '}
          <Link to={buildLocalizedPath('/about', language)} tabIndex={-1}>
            {t('navAbout')}
          </Link>
          .
        </p>
      </section>
    </div>
  );
};
